export default __webpack_public_path__ + "static/media/reports.75a9c185.svg";